import type { ReactNode } from 'react'
import { Inbox } from 'lucide-react'
import styles from './style.module.css'

interface EmptyStateProps {
  title?: string
  description?: ReactNode
  icon?: ReactNode
  action?: ReactNode
}

const EmptyState = ({ action, description, icon, title }: EmptyStateProps) => (
  <div className={styles.wrapper}>
    <span className={styles.icon}>{icon ?? <Inbox size={28} />}</span>
    <strong className={styles.title}>{title ?? 'Não há dados a serem exibidos!'}</strong>
    {description ? <span className={styles.description}>{description}</span> : null}
    {action}
  </div>
)

export default EmptyState
